<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="pageTitle"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    <tidy-card>
      <tidy-row class="extra-bottom-padding" [align]="'center'">
        <tidy-image
          [src]="selectedIntegration?.logo_url"
          style="width:80%; max-height: 200px" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [header]="selectedIntegration?.name" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="selectedIntegration?.short_description" />
      </tidy-row>
      <tidy-row class="extra-top-padding extra-bottom-padding">
        <tidy-divider />
      </tidy-row>
      <form [formGroup]="form" novalidate action="#">
        @if (selectedIntegration?.type !== 'accounting') {
          <tidy-row class="field-top-padding">
            <tidy-textarea
              formControlName="note"
              [form]="form.controls.note"
              [label]="'Instructions for your vendors'"
              [icon]="'assets/svg/information-circle.svg'" />
          </tidy-row>
          <tidy-row class="field-top-padding">
            <tidy-input
              formControlName="numberOfProperties"
              [form]="form.controls.numberOfProperties"
              [label]="'Number of properties to use for this'"
              [icon]="'assets/svg/home.svg'" />
          </tidy-row>
        }
        @if (selectedIntegration?.type === 'accounting') {
          <tidy-row class="field-top-padding">
            <tidy-textarea
              formControlName="note"
              [form]="form.controls.notesForConcierge"
              [label]="'Any notes for our concierge?'"
              [icon]="'assets/svg/information-circle.svg'" />
          </tidy-row>
        }
      </form>
    </tidy-card>

    <tidy-button
      [text]="'Request Integration'"
      [action]="boundRequestIntegration"
      class="primary" />

    @if (selectedIntegration?.type === 'thermostats') {
      <tidy-row>
        <tidy-text
          [body]="'By integrating with smart thermostats like'" /><span>&nbsp;</span>
          <tidy-text
            [body]="selectedIntegration?.name + ','" /><span>&nbsp;</span>
            <tidy-text
              [body]="'you can set up rules for how temperature should work around jobs. Popular examples of uses include:'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'<li>Setting min or max temperature during the time of the job. This allows you to ensure your pro is comfortable, while ensuring that energy is conserved.</li>'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'<li>Set the temperature after jobs are over, so that you can conserve energy.</li>'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'<li>Save energy and maintain comfort by integrating with smart thermostat systems.</li>'" />
          </tidy-row>
        }

        @if (selectedIntegration?.type === 'locks') {
          <tidy-row>
            <tidy-text
              [body]="'Integrating TIDY with'" /><span>&nbsp;</span>
              <tidy-text
                [body]="selectedIntegration?.name" /><span>&nbsp;</span>
                <tidy-text
                  [body]="'allows you to control access to your home with your cleaning and maintenance vendors. Typically, this is used so you can automatically give pros access to the properties only when they need access.'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'Once integrated, you can:'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'<li>Unlock and lock your properties from your interface.</li>'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'<li>Automatically create one time passwords to access your property during jobs.</li>'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'<li>Automatically unlock properties when pros indicate they have arrived and lock when they leave.</li>'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'<li>Use the API to control</li>'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'<li>Control access to your properties for both cleaning and maintenance.</li>'" />
              </tidy-row>
            }


          </tidy-wrapper>
        </ng-template>

        @if (!isRightSideContent) {
          <app-scroll-wrapper [templateContent]="content" />
        }

        @if (isRightSideContent) {
          <ion-content class="ion-content-right-column">
            <ng-container *ngTemplateOutlet="content" />
          </ion-content>
        }
